import { addValidator } from 'redux-form-validators'
import pluralize from 'pluralize'

export const valueRequired = value => {
  if (!value) {
    return 'A selection is required'
  }
}

export const noSpacesAllowed = value => {
  if (value && value.trim() !== value) {
    return 'Value cannot begin or end with a space'
  }
}

export const arrayMinLength = addValidator({
  defaultMessage: '',
  validator: function(options, value, allValues) {
    if (options.length > 0 && value.length < options.length) {
      return {
        id: 'form.errors.arrayMinLength',
        defaultMessage: `Make at least ${pluralize(
          'selection',
          options.length,
          true
        )}`
      }
    }
  }
})

export const arrayMaxLength = addValidator({
  defaultMessage: '',
  validator: function(options, value, allValues) {
    if (options.length > 0 && value.length > options.length) {
      return {
        id: 'form.errors.arrayMaxLength',
        defaultMessage: `Maximum ${pluralize(
          'selection',
          options.length,
          true
        )} allowed`
      }
    }
  }
})

// To use properly you must create validator outside of render, these are helpers for that
export const minSelect = value => arrayMinLength({ length: value })
export const maxSelect = value => arrayMaxLength({ length: value })
